import { types } from './types';
import { types as formTypes } from 'store/form/types';
import { instance, getQueryString } from 'store/utils';
import { store } from 'store';
import { homeUrl, loginUrl, localLoginUrl, authErrorUrl } from 'utils';
import keycloak from 'Keycloak.js';

const getOAuth2ClientsEndpoint = "/app/oauth2-clients";
const loginCheckerEndpoint = "/app/rest/account-checker";
const askTempPasswordEndpoint = "/app/temp-password";
const setNewPasswordEndpoint = "/app/rest/new-password";
const loginEndpoint = "/app/authentication";
const authenticateEndpoint = "/idm-app/rest/authenticate";
const accountEndpoint = "/idm-app/rest/account";

export const getUser = processInstanceId => dispatch => {
    const url = '/app/rest/account-extended-with-deadline';
    dispatch({ type: types.GET_USER.START });
    instance
      .get(url, { params: { processInstanceId } })
      .then(response => {
        dispatch({ type: types.GET_USER.SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: types.GET_USER.ERROR, payload: error.message });
      });
  };

export const getOAuth2Clients = () => dispatch => {
    instance
      .get(getOAuth2ClientsEndpoint)
      .then(response => {
        if (response.data.hasOwnProperty("gsis")) {
          dispatch({ type: formTypes.SET_FORM_GSIS_AUTH, payload: response.data.gsis });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };  

  export const initiateLoginFlow = params => dispatch => {
    dispatch({ type: formTypes.UNSET_FORM_MESSAGE });
    dispatch({ type: formTypes.SET_FORM_LOADING });
    if (params.username.trim() == "") {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Το email δε μπορεί να είναι κενό" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    if (params.password.trim() == "") {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Ο κωδικός δε μπορεί να είναι κενός" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    keycloak.tracker.invalidateUserForAuthPages(true, () => {
      dispatch(login(params));
    });
  };

  export const initiateGsisLogin = url => dispatch => {
    dispatch({ type: formTypes.UNSET_FORM_MESSAGE });
    dispatch({ type: formTypes.SET_FORM_LOADING });
    window.location.href = window.location.protocol + '//' + window.location.hostname + process.env.REACT_APP_BACKEND_HOST_PORT + "/" + process.env.REACT_APP_FLOWABLE_CONTEXT_PATH+ "/" + url;
    dispatch({ type: formTypes.UNSET_FORM_LOADING });
  };

  export const initiateAskTempPasswordFlow = params => dispatch => {
    dispatch({ type: formTypes.UNSET_FORM_MESSAGE });
    dispatch({ type: formTypes.SET_FORM_LOADING });
    // initial validity checks
    if (params.username.trim() == "") {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Το email δε μπορεί να είναι κενό" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    const uniqueFlow = { started: false };
    keycloak.tracker.invalidateUserForAuthPages(true, () => {
      dispatch(askTempPassword(params, uniqueFlow));
    });
  };

  export const initiateNewPasswordFlow = params => dispatch => {
    dispatch({ type: formTypes.UNSET_FORM_MESSAGE });
    dispatch({ type: formTypes.SET_FORM_LOADING });
    // initial validity checks
    if (params.password.trim() == "") {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Ο νέος κωδικός δε μπορεί να είναι κενός" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    else if (params.confirmPassword.trim() == "") {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Ο κωδικός επιβεβαίωσης δε μπορεί να είναι κενός" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    else if (params.confirmPassword !== params.password) {
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: "Ο κωδικός επιβεβαίωσης δεν ταιριάζει με το νέο κωδικό" });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
      return;
    }
    const uniqueFlow = { started: false };
    keycloak.tracker.invalidateUserForAuthPages(false, (data) => {
      keycloak.tracker.installMonitorIdmSession(data, true);
      redirectToAuthError("invalidOperation");
    }, (data) => {
      dispatch(setNewPassword(params, uniqueFlow));
    }); 
  };

  export const redirectToHome = () => {
    keycloak.redirectToHome();
  };

  const askTempPassword = (params, uniqueFlow) => dispatch => {
    if (uniqueFlow.started) return;
    uniqueFlow.started = true;
    dispatch({ type: types.ASK_USER_TEMP_PASSWORD.START });
    const data = {
      email: params.username,
    };
    instance
      .post(askTempPasswordEndpoint, data)
      .then(response => {
        dispatch({ type: types.ASK_USER_TEMP_PASSWORD.SUCCESS, payload: response.data });
        redirectToLocalLogin("origin=forgotPass");
      })
      .catch(error => {
        dispatch({ type: types.ASK_USER_TEMP_PASSWORD.ERROR, payload: error.message });
        dispatch({ type: formTypes.SET_FORM_ERROR, payload: error.message });
        dispatch({ type: formTypes.UNSET_FORM_LOADING });
      });
  };

  const setNewPassword = (params, uniqueFlow) => dispatch => {
    if (uniqueFlow.started) return;
    uniqueFlow.started = true;
    dispatch({ type: types.SET_USER_NEW_PASSWORD.START });
    const data = {
      password: params.password,
    };
    instance
      .post(setNewPasswordEndpoint, data)
      .then(response => {
        dispatch({ type: types.SET_USER_NEW_PASSWORD.SUCCESS, payload: response.data });
        keycloak.logout();
      })
      .catch(error => {
        dispatch({ type: types.SET_USER_NEW_PASSWORD.ERROR, payload: error.message });
        dispatch({ type: formTypes.SET_FORM_ERROR, payload: error.message });
        dispatch({ type: formTypes.UNSET_FORM_LOADING });
      });
  };

  const login = params => dispatch => {
  dispatch({ type: types.LOGIN_USER.START });
  const data = {
    j_username: params.username,
    j_password: params.password,
    _spring_security_remember_me: "true",
    j_remember_me: params.rememberMe,
    submit: "Login",
  };
  instance
    .post(loginEndpoint, getQueryString(data))
    .then(response => {
      dispatch({ type: types.LOGIN_USER.SUCCESS, payload: response.data });
      keycloak.tracker.invalidateUser(() => {
        //dispatch(authenticate(params.rememberMe));
        authConfirmed({userMustChangePassword: false, rememberUser: params.rememberUser});
      }, undefined, () => {
        authConfirmed({userMustChangePassword: true, rememberUser: params.rememberMe});
      });
    })
    .catch(error => {
      dispatch({ type: types.LOGIN_USER.ERROR, payload: error.message });
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: error.message });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
    });
};

const authenticate = (rememberUser) => dispatch => {
  dispatch({ type: types.AUTHENTICATE_USER.START });
  const data = {
    ignoreErrors: true,
    ignoreAuthModule: "ignoreAuthModule",
  };
  instance
    .get(authenticateEndpoint, data)
    .then(response => {
      dispatch({ type: types.AUTHENTICATE_USER.SUCCESS, payload: response.data });
      const redirectOnAuthSuccess = getLocationSearch().redirectOnAuthSuccess;
      if (!redirectOnAuthSuccess) {
        dispatch(account(rememberUser));
      }
    })
    .catch(error => {
      dispatch({ type: types.AUTHENTICATE_USER.ERROR, payload: error.message });
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: error.message });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
    });
};

const account = (rememberUser) => dispatch => {
  dispatch({ type: types.GET_ACCOUNT.START });
  instance
    .get(accountEndpoint)
    .then(response => {
      dispatch({ type: types.GET_ACCOUNT.SUCCESS, payload: response.data });
      authConfirmed({userMustChangePassword: false, rememberUser: rememberUser});
    })
    .catch(error => {
      dispatch({ type: types.GET_ACCOUNT.ERROR, payload: error.message });
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: error.message });
      dispatch({ type: formTypes.UNSET_FORM_LOADING });
    });
};

const authConfirmed = (data) => {
  console.log('DATA :', data)
  keycloak.setPostLoginActions(data, authConfirmedCont);
};

const authConfirmedCont = (data) => {
  if (data.userMustChangePassword) {
    keycloak.redirectToNewPassword();
  }
  else {
    const redirectUrl = getLocationSearch().redirectUrl;
    if (redirectUrl !== null && redirectUrl !== undefined && redirectUrl.length > 0) {
      window.location.href = redirectUrl;
    } else {
      const locationPath = getLocationPath();
      if (locationPath === '' || locationPath === '#' || locationPath === '/login' || locationPath === '/') {
        keycloak.redirectToHome();
      } else if (locationPath.indexOf('/account/activate/') >= 0 || locationPath.indexOf('/account/reset-password/') >= 0) {
        keycloak.redirectToHome();
      }
    }
  }
};

const redirectToLogin = () => {
  window.location.href = loginUrl;
};

const redirectToAuthError = (reason) => {
  var urlParams = "";
  if (typeof reason != "undefined" && reason.trim() != "") {
    urlParams = "?reason=" + encodeURIComponent(reason.trim());
  }
  window.location.href = authErrorUrl + urlParams;
};

const redirectToLocalLogin = (params) => {
  var urlParams = "";
  if (typeof params != "undefined" && params.trim() != "") {
    urlParams = "?" + params.trim();
  }
  window.location.href = localLoginUrl + urlParams;
};

const getLocationPath = () => {
  const path = window.location.hash.replace(/^#(.*?)(\?.*$|$)/, "$1");
  if (path == "") return "/";
  return path;
};

const getLocationSearch = () => {
  if (!window.location.hasOwnProperty("search") || typeof window.location.search != "object") {
    return {};
  }
  else return window.location.search;
};

instance.interceptors.response.use(undefined, err => {
  const {dispatch} = store;
  const request = err.request;
  const error = err.response;
  if (request.responseURL.endsWith(loginCheckerEndpoint)) {
    const errorMessage = "Σφάλμα συστήματος. Παρακαλούμε προσπαθήστε αργότερα.";
    dispatch({ type: formTypes.SET_FORM_ERROR, payload: errorMessage });
  }
  else if (request.responseURL.endsWith(loginEndpoint)) {
    const errorMessage = (error.status == 401 ?
      "Λανθασμένο όνομα χρήστη ή κωδικός πρόσβασης." :
      "Σφάλμα συστήματος. Παρακαλούμε προσπαθήστε ξανά.");
      error.message = errorMessage;
  }
  else if (request.responseURL.endsWith(authenticateEndpoint) || request.responseURL.endsWith(accountEndpoint)) {
    if (error.status == 401) {
      redirectToLogin();
    }
    else {
      const errorMessage = "Σφάλμα σύνδεσης. Παρακαλούμε προσπαθήστε ξανά.";
      error.message = errorMessage;
    }
  }
  else if (request.responseURL.endsWith(setNewPasswordEndpoint)) {
    if (error.status == 400 && error.data && error.data.messageKey && error.data.messageKey == "GENERAL.ERROR.BAD-PASSWORD") {
      const errorMessage = "Ο νέος κωδικός δεν είναι έγκυρος. Θα πρέπει να έχει μήκος τουλάχιστον 8 χαρακτήρες και να περιέχει τουλάχιστον ένα κεφαλαίο, έναν αριθμό και δυο ειδικούς χαρακτήρες (!@#$%^&*()+).";
      dispatch({ type: formTypes.SET_FORM_ERROR, payload: errorMessage });
      error.message = errorMessage;
      console.log("keys: ", Object.keys(error));
      console.log("data: ", error.data);
      console.log("status: ", error.status);
      console.log("statusText: ", error.statusText);
      console.log("headers: ", error.headers);
      console.log("config: ", error.config);
      console.log("request: ", error.request);
    }
  }
  return Promise.reject(error);
});
